module.exports = __webpack_public_path__ + "img/hole-1.5b605312.png";